
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block;
}

.tag {

    display: inline-block;

    cursor: pointer;

    border-radius: 10px;

    border-width: 1px;

    border-style: solid;

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    font-weight: var(--fw-semibold);

    text-decoration-line: none;
}

@media (min-width: 768px) {

    .tag {

        padding-left: 2.25rem;

        padding-right: 2.25rem;
    }

    .tag {

        padding-top: 1rem;

        padding-bottom: 1rem;
    }
}

.tag--base {

    border-color: var(--primary-blue-dark);

    color: var(--primary-blue-dark);
}

.tag--base:hover {

    background-color: var(--primary-blue-dark);
}

.tag--base:hover {

    color: var(--neutral-white);
}

.tag--base:hover {

    text-decoration-line: underline;
}

.tag--chip {

    border-radius: 1rem;

    border-color: var(--neutral-gray-2);

    padding-left: 0.75rem;

    padding-right: 0.75rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    font-family: var(--ff-body);

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);

    color: var(--neutral-gray-1);
}

.tag--chip:hover {

    background-color: var(--outline-gray-200);
}

.tag--chip.tag--active {

    border-color: var(--primary-green);
}

.tag--chip.tag--active {

    background-color: var(--primary-green);
}

.tag--chip.tag--active {

    color: var(--neutral-white);
}
`;